import config from '@/config/user.env.js';
/**
 * 文件在线预览接口
 * @param fileObj {Object}
 * @param fileObj.fileName {String} 附件文件名
 * @param fileObj.fileId {String} 附件ID
 * @param fileObj.fileUrl {String} 附件url
 * @return {undefined}
 *
 * **/
export function filePreview(fileObj, callback) {
    const fileArr = fileObj.fileUrl.split('.');
    const ext = (fileObj.fileType || fileArr[fileArr.length - 1]);
    let fileName = '';
    if (/\./.test(fileObj.fileName)) {
        fileName = fileObj.fileName;
    } else {
        fileName = fileObj.fileName + '.' + ext;
    }
    const url = config.filePreviewUrl + '/mip-doc-preview/viewer.html?sys=lsrm'
    + '&sign=' + new Date().getTime()
    + '&ext=' + ext
    + '&fd=' + fileObj.fileId
    + '&name=' + fileName
    + '&src=' + encodeURIComponent(fileObj.fileUrl);

    if (callback) {
        return callback(url);
    }

    window.open(url, '_blank ');
};
